import React, { useState, useEffect } from 'react'
import { TabProvider, useTab } from './TabContext'
import './Tabs.scss'

export const Tabs = ({ children, defaultIndex }) => {
  return (
    <TabProvider defaultIndex={defaultIndex}>
      {children}
    </TabProvider>
  )
}

export const TabList = ({ children, extra }) => {
  return (
    <div className="tab-list">
      <div className="tab-list-tabs">
        {children}
      </div>
      <div className='tab-list-extra'>
        {extra.map((Component, idx) => (
          <span key={idx}>{Component}</span>
        ))}
      </div>
    </div>
  )
}

export const Tab = ({ index, children }) => {
  const { activeIndex, setActiveIndex } = useTab()

  return (
    <div className={`tab pb5 ${activeIndex === index ? 'link ml5 df ai-fs mr25 fz15 c-blue-700 tdn oln' : 'df ai-fs ml5 mr25 fz15 c-neutral-500 tdn oln'}`} onClick={() => setActiveIndex(index)}>
      {children}
    </div>
  )
}

export const TabPanel = ({ index, children }) => {
  const { activeIndex } = useTab()
  const [hasBeenActive, setHasBeenActive] = useState(false)

  useEffect(() => {
    if (activeIndex === index) {
      setHasBeenActive(true)
    }
  }, [activeIndex, index])

  if (!hasBeenActive) return null

  return (
    <div className={`tab-panel ${activeIndex === index ? '' : 'dn'}`}>
      {children}
    </div>
  )
}
